import { render, staticRenderFns } from "./PlansTable.vue?vue&type=template&id=068f8eb7"
import script from "./PlansTable.vue?vue&type=script&lang=js"
export * from "./PlansTable.vue?vue&type=script&lang=js"
import style0 from "./PlansTable.vue?vue&type=style&index=0&id=068f8eb7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports